import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { GetCurrentUserRoles } from "@/gql/assistant/documents/Me/GetCurrentUserRoles.document";
import { useAuth } from "@/contexts/AuthContext";
import { ADMIN_TOOLS_ROLE_NAMES, GLOBAL_ADMINISTRATOR_ROLE, hasAnyRole } from "@/auth/roles";

type UseCurrentUserRolesOptions = {
  enabled?: boolean;
};

export function useCurrentUserRoles(options?: UseCurrentUserRolesOptions) {
  const { authInitialized, isAuthenticated } = useAuth();
  const enabled = options?.enabled ?? true;

  const { data, loading, error } = useQuery(GetCurrentUserRoles, {
    fetchPolicy: "cache-first",
    skip: !enabled || !authInitialized || !isAuthenticated,
  });

  const roles = useMemo(() => {
    return data?.me?.profile?.roles ?? [];
  }, [data?.me?.profile?.roles]);

  const isGlobalAdmin = useMemo(() => {
    return hasAnyRole(roles, [GLOBAL_ADMINISTRATOR_ROLE]);
  }, [roles]);

  const canViewAdminTools = useMemo(() => {
    return hasAnyRole(roles, ADMIN_TOOLS_ROLE_NAMES);
  }, [roles]);

  return {
    roles,
    isGlobalAdmin,
    canViewAdminTools,
    loading,
    error,
  };
}

export default useCurrentUserRoles;
